import React from 'react'
import { useParams } from 'react-router-dom'
import Apploader from '@/layout/AppLoader'
import SafelineEntry from './SafelineEntry'

const App = () => {
  const { app_key = '' } = useParams()
  if (/^safeline-cloud(?:-\d+)?$/.test(app_key)) {
    return <SafelineEntry />
  }
  return <Apploader />
}

export default App
